import { ManageDeskBookingsFiltersSchema } from './DeskBookingsFiltersDrawer';

export const defaultFilters: ManageDeskBookingsFiltersSchema = {
    userId: '',
    deskNumber: '',
    endDate: null,
    startDate: null,
};
